import React from "react";
import {
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import { SectionCard } from "./StyledComponents";

const BatchSelector = ({ batches, selectedBatch, onBatchChange, onRefresh }) => {
  return (
    <SectionCard>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Generation Batch</InputLabel>
              <Select
                label="Generation Batch"
                value={selectedBatch}
                onChange={(e) => onBatchChange(e.target.value)}
              >
                {batches.map((batch) => (
                  <MenuItem key={batch.batch_id} value={batch.batch_id}>
                    #{batch.batch_id} • {batch.status} •{" "}
                    {new Date(batch.created_at).toLocaleString()}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={onRefresh}
            >
              Refresh
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </SectionCard>
  );
};

export default BatchSelector;
